import {IconButton, TableRow} from 'platform/components';
import {HStack, Link, Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {useGetCustomerV2Query} from '@dms/api/customer';
import {useGetVehicleQuery} from '@dms/api/sales';
import {FastTruckIssue} from '@dms/api/warehouse';
import {customerRoutes, vehiclesRoutes, warehouseRoutes, workshopRoutes} from '@dms/routes';
import {getCustomerName} from '@dms/shared';

import {composePath} from 'shared/web';

import {FastTrackTableCell} from './FastTrackTableCell';

export interface FastTrackIssueTableRowProps {
  fastTruckIssue: FastTruckIssue;
  onAcceptIssue: (fastTruckIssue: FastTruckIssue) => void;
  isReceiveNoteCompleted: boolean;
}

export function FastTrackIssueTableRow(props: FastTrackIssueTableRowProps) {
  const formatDateTime = useDateTimeFormatter();

  const customerQuery = useGetCustomerV2Query(
    {
      customerId: props.fastTruckIssue.customerOrderCustomerId,
    },
    {skip: !props.fastTruckIssue.customerOrderCustomerId}
  );

  const vehicleQuery = useGetVehicleQuery(
    {
      vehicleId: props.fastTruckIssue.customerOrderVehicleId,
    },
    {skip: !props.fastTruckIssue.customerOrderVehicleId}
  );

  const formatedFastTruckDate = formatDateTime('dateTimeShort', props.fastTruckIssue.fastTruckDate);
  const formatedCustomerOrderCreatedAt = formatDateTime(
    'dateTimeShort',
    props.fastTruckIssue.customerOrderCreatedAt
  );

  const customerName = getCustomerName(customerQuery.data);

  const vehicleName = vehicleQuery.data?.title || '';
  const registrationPlate = vehicleQuery.data?.state?.registrationPlate || '';

  const handleClick = () => {
    props.onAcceptIssue(props.fastTruckIssue);
  };

  return (
    <TableRow
      color={props.fastTruckIssue.isSelectionAllowed ? 'general.white' : 'palettes.neutral.10.100'}
    >
      <HStack justify="center">
        <IconButton
          onClick={handleClick}
          isDisabled={!props.fastTruckIssue.isSelectionAllowed || props.isReceiveNoteCompleted}
          icon={props.fastTruckIssue.isSelected ? 'action/check_circle' : 'action/uncheck_circle'}
          severity={props.fastTruckIssue.isSelected ? 'success' : undefined}
        />
      </HStack>
      <FastTrackTableCell>
        <Link
          href={composePath(warehouseRoutes.fastTrackIssuesDetailOverview, {
            params: {id: props.fastTruckIssue.fastTruckId ?? ''},
            isSearchParamsPreserved: false,
          })}
          target="_blank"
          title={props.fastTruckIssue.fastTruckNumber}
        />
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">TODO</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">{formatedFastTruckDate}</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">{props.fastTruckIssue.fastTruckQuantity}</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">{props.fastTruckIssue.fastTrackNote}</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Link
          href={composePath(workshopRoutes.serviceCaseDetail, {
            params: {id: props.fastTruckIssue.fastTrackOriginEntityHeaderServiceCaseId ?? ''},
            isSearchParamsPreserved: false,
          })}
          target="_blank"
          title={props.fastTruckIssue.customerOrderNumber}
        />
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">{formatedCustomerOrderCreatedAt}</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Link
          href={composePath(vehiclesRoutes.detail, {
            params: {id: props.fastTruckIssue.customerOrderVehicleId ?? ''},
            isSearchParamsPreserved: false,
          })}
          target="_blank"
          title={vehicleName}
        />
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Text size="small">{registrationPlate}</Text>
      </FastTrackTableCell>
      <FastTrackTableCell>
        <Link
          href={composePath(customerRoutes.detail, {
            params: {id: props.fastTruckIssue.customerOrderCustomerId ?? ''},
            isSearchParamsPreserved: false,
          })}
          target="_blank"
          title={customerName}
        />
      </FastTrackTableCell>
    </TableRow>
  );
}
